export default __webpack_public_path__ + "bac7ed87f9bcd95a6c55742ef49edf8f.ttf";